import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchBalanceOnHandPastInfo = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getBalanceOnHandPastInfo',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
    queryStringParams: {
      startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
      endDate: moment(payload.params.endDate).format('YYYY-MM-DD'),
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchBalanceOnHandPastInfo;
